export default __webpack_public_path__ + "static/media/warning-circle.018d1d85.svg";